import React, { useState } from 'react';
import { Comment, Id, Review } from '../../interfaces/types';
import { useUserContext } from '../../providers/userProvider';
import uuidv4 from 'uuid-random';
import { useCommentContext } from '../../providers/CommentProvider';
import { Alert, Box, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Snackbar } from '@mui/material';
import { Send } from '@mui/icons-material';

interface CreateCommentFormProps {
    review: Review;
}

const CreateCommentForm: React.FC<CreateCommentFormProps> = ({ review }) => {
    const { userDetails } = useUserContext();
    const { addComment } = useCommentContext();
    const [openSnackbar, setOpenSnackbar] = useState<boolean>(false);
    const [snackbarMessage, setSnackbarMessage] = useState<string>("");
    const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">("success");

    const defaultComment: Comment = {
        id: uuidv4(),
        reviewId: review.id,
        createdBy: userDetails?.uid as Id,
        createdAt: new Date(),
        content: '',
        isNew: true,
    };
    const [newComment, setNewComment] = useState<Comment>(defaultComment);

    const handleCloseSnackbar = (
        event?: React.SyntheticEvent | Event,
        reason?: string
    ) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSnackbar(false);
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        try {
            if (newComment.content.trim() === '') throw new Error('Comment cannot be empty!');
            addComment(newComment);
            setNewComment(defaultComment);

            setSnackbarMessage("Comment successfully submitted!");
            setSnackbarSeverity("success");
            setOpenSnackbar(true);
        } catch (error) {
            setSnackbarMessage("Comment submit has failed!");
            if (error instanceof Error && error.message === 'Comment cannot be empty!') setSnackbarMessage(error.message);
            setSnackbarSeverity("error");
            setOpenSnackbar(true);
        }
    };

    return (
        <Box component={'form'} onSubmit={handleSubmit} sx={{ width: '100%' }} justifyContent={'center'} alignItems={'center'} display={'flex'}>
            <FormControl sx={{ width: '100%' }} variant="outlined">
                <InputLabel htmlFor={`send-comment-${review.id}`}>Comment</InputLabel>
                <OutlinedInput
                    multiline
                    id={`send-comment-${review.id}`}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                            size='small'
                                aria-label='comment'
                                onClick={handleSubmit}
                                edge="end"
                            >
                                <Send />
                            </IconButton>
                        </InputAdornment>
                    }
                    onChange={(e) =>
                        setNewComment({
                            ...newComment,
                            content: e.target.value,
                        })
                    }
                    label="Password"
                />
            </FormControl>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={2000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default CreateCommentForm;